var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.594 10.355a7 7 0 1 1 0-4.71l-1.884.673A5.002 5.002 0 0 0 3 8a5 5 0 0 0 9.71 1.682l1.884.673z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.6 6.302 1.891-.65L15.382 5l-.914 3.488L11.6 6.302z",
    fill: "currentColor"
  })));
};
export { SvgRefresh as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjU5NCAxMC4zNTVhNyA3IDAgMTEwLTQuNzFsLTEuODg0LjY3M0E1LjAwMiA1LjAwMiAwIDAwMyA4YTUgNSAwIDAwOS43MSAxLjY4MmwxLjg4NC42NzN6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTEuNiA2LjMwMmwxLjg5MS0uNjVMMTUuMzgyIDVsLS45MTQgMy40ODhMMTEuNiA2LjMwMnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";